// import { Store } from 'vuex'
import store from '@/store'

const montarFormularioPreview = (form) => {  
    const campos = gerarCampo(form)
    console.log('Função de montagem do preview: ', campos)
    return campos
}

const gerarCampo = (form) => {
  let campos = []

  let rows = agruparPorLinha(form.corpo)
  
  rows.map((linha, linhaIndex) => {
    return linha.campos.map((campo) => {      
      let ctrlCampo = getCampo(campo.id)
      console.log('Debug Expressoes Logicas ', campo, ctrlCampo)

      campos.push({
        ...ctrlCampo,
        linha: linhaIndex + 1,
        id: campo.id,
        label: ctrlCampo.label,
        type: ctrlCampo.campo_oculto ? 'hidden' : ctrlCampo.tipo_campo,
        name: ctrlCampo.name,
        placeholder: ctrlCampo.placeholder,
        desc_ajuda: ctrlCampo.desc_ajuda || '',
        value: campo.valor_padrao ? campo.valor_padrao : ctrlCampo.valor_padrao,
        show: campo.show,
        validation: gerarValidation(campo),
        validation_verify: gerarValidation(campo),
        col: 'col-md-' + 12 / linha.colunas,
        options: gerarOptionsCampos(ctrlCampo.ctrl_campos_opcoes),
        ctrl_formulario_subcampos: campo.ctrl_formulario_subcampos,
        indice_ficha: ctrlCampo.ctrl_indice_ficha_tecnica_id ? ctrlCampo.ctrl_indice_ficha_tecnica.indice : "",
        expressoes_logicas_externas: campo.expressoes_logicas_externas,
        readonly: campo.readonly || false,
        computed: campo.computed || null,
      })

      if(campo.ctrl_formulario_subcampos.length) {
        campo.ctrl_formulario_subcampos.forEach(subcampo => {           
          let sub = {
            "id": campo.id,
            "label": subcampo.label,
            "type": "select-avancado",
            "options": gerarOptionsSubcampo(subcampo.options),
            "validation": "",
            "name": subcampo.name,
            "nome_enderecamento": campo.name,
            "show": `(this.values.${campo.name} !== '')`,
            "posicao": 1,
            "col": `col-md-${12 / linha.colunas}`,
            "placeholder": "",
            "desc_ajuda": "",
            "expressoes_logicas_externas": campo.expressoes_logicas_externas,
            "indice_ficha": ctrlCampo.ctrl_indice_ficha_tecnica_id ? ctrlCampo.ctrl_indice_ficha_tecnica.indice : ""
          }
          campos.push(sub)
        })
      }
    })
  })
  return campos;
}

function getCampo (id) {
  const { data } =  store.getters['ctrlCampos/listaDeCtrlCampos']

  if (data && data.length) {
    console.log('Este é o campo: ', data.find(campo => campo.id == id), id)
    return data.find(campo => campo.id == id)
  }

  return []
}

// function validaRegraDeVizualizacaoCampo (campo) {
//   let listaDeRegras = []

//   console.log('Validação do campo ', campo)

//   if (campo.expressoes_logicas == null) return true
  
//   campo.expressoes_logicas.map(exp => {
//     const campoGatilho = getCampo(exp.ctrl_campo_id)
//     const objExpressaoBooleana = recuperaExprsssoaBooleanaPorId(exp.ctrl_expressao_booleana_id)        
//     const expressao = `this.values.${campoGatilho.name} ${objExpressaoBooleana.comando} ${exp.verificador ? "'" + exp.verificador + "'" : "''" }`
//     listaDeRegras.push(expressao)
//   })

//   if (listaDeRegras.length) {
//     return listaDeRegras.join(' && ')
//   }

//   return true
// }

// function recuperaExprsssoaBooleanaPorId(id) {
//   const listaDeExpressoesBooleanas = store.getters['ctrlFormularioDinamico/listaDeExpressoesBooleanas']
//   return listaDeExpressoesBooleanas.find(exp => exp.id === id)
// }

function gerarValidation (campo) {
  let validation = campo.obrigatorio ? 'required' : ''

  console.log('Gerar Validação ', campo)

  if (campo.min) {
    validation = validation ? `${validation}|min:${campo.min}` : `required|min:${campo.min}`
  }

  if (campo.max) {
    validation = validation ? `${validation}|max:${campo.max}` : `max:${campo.max}`
  }

  return validation
}

function gerarOptionsCampos (options) {
  let opcoes = [
      ...options.map(option => {
        return {
          label: option.label,
          value: option.val
        }
      })
    ]

  opcoes = opcoes.reduce((acc, item) => {
    acc[`${item.value}`] = item.label;
    return acc;
  }, {})

  return opcoes
}

function gerarOptionsSubcampo (options) {
  let optionsData = {}


  console.log('Options do subcampo: ', options)

  options.forEach(option => {        
    if (optionsData[option.valor_comparacao] == null) {
      optionsData[option.valor_comparacao] = []
    }        
    optionsData[option.valor_comparacao].push(option)
  })

  // transforma tudo em objeto para não quebrar o backend,
  // que pede objeto ao invés de arrau no options dos campos de indice ficha tecnica
  for (const [key] of Object.entries(optionsData)) {        
      optionsData[key] = optionsData[key].reduce((acc, item) => {
      acc[`${item.value}`] = item.label;
      return acc;
    }, {})
  }

  return optionsData
}


const agruparPorLinha = (form) => {
  const resultado = [];
  form.forEach(obj => {
    if (!resultado[parseInt(obj.linha)-1]) {
      resultado[parseInt(obj.linha)-1] = {
        colunas: 1,
        campos: []
      }
    }

    resultado[parseInt(obj.linha)-1].colunas = form.length
    resultado[parseInt(obj.linha)-1].campos.push({
      ...obj, 
      colunas: form.length
    });
  })
  return resultado;
}

export {
  montarFormularioPreview,
  agruparPorLinha,
  gerarCampo
}